module.exports = __webpack_public_path__ + "static/media/headerLogo.ed421d33.png";